import React, { PureComponent } from 'react';
import cookie from 'react-cookies';
import { connect } from 'react-redux';
import Router from 'next/router';
import DevicesGrid from '~/src/components/Equipment/internet/devicesGrid';
import ClientRouter from '~/src/components/Equipment/banners/clientRouter';
import { dataLayerPush } from '@ertelecom/ui-react/components/helpers';
import GridContainer from '@ertelecom/ui-react/components/layouts/gridContainer';
import PopupResult from '@ertelecom/ui-react/components/popups/popupResult';
import { getClientId } from '~/src/helpers/clientInfo';
import {
    sendRequestByConnection,
    parseRequestByConnection,
    dataLayerForCBPhonePushWrapper,
} from '~/src/api/service-request/request-by-connection';
import Info from '~/src/components/Equipment/banners/info';
import QuizBlock from '~/src/components/QuizBlock';
import OrderPopup from '~/src/components/Equipment/internet/orderPopup';
import {
    Wrapper,
    RouterListTitle,
    RouterListContainer,
    InfoContainer,
    Title,
    QuizSection,
    BannerRouter,
} from '~/src/components/Equipment/internet/styled';
import { captureException } from '@sentry/node';
import { selectDomain } from '~/src/store/selectors/domain';
import { EPriceTypes } from '~/src/models/price';
import { ACTIONS, EVENTS } from '~/src/constants/analytics';
import { dataLayerForCBPhonePush } from '~/src/helpers/eventsForDataLayer';

const INSTALLMENT_TEXT = 'рассрочка';
const PURCHASE_TEXT = 'покупка';

const PRODUCT_INTERNET_ID = 5;
const PRODUCT_TV_ID = 53;

class Main extends PureComponent {
    state = {
        clientRouter: null,
        isAuthOpened: false,
        resultTitle: null,
        resultText: null,
        resultType: 'success',
        isResult: false,
        isAuth: false,
    };

    componentDidMount() {
        const { isAuth } = this.props;

        if (process.browser && isAuth) {
            this.setState({
                isAuth: true,
            });
        }
    }

    componentDidUpdate() {
        const { isAuth } = this.props;
        if (!isAuth) {
            this.setState({
                isAuth: false,
            });
        }
    }

    createOrderUnauth = (router) => {
        const { currentCity } = this.props;
        const { selectRouter } = this.state;
        const clientId = cookie.load('_ga_cid');
        const { tv_equipment_id, tv_equipment_duration, phone, fio, option, isPopup } = router;
        const params = {
            fio: fio,
            phone: phone,
            product_id: 5,
            router: tv_equipment_id,
            leasing_duration: tv_equipment_duration,
            domain: currentCity.domain,
            cost_type: selectRouter.option.type ? selectRouter.option.type : 5,
            ga_cid: clientId ? clientId : getClientId(),
        };

        return sendRequestByConnection(currentCity.domain, params)
            .then(res => {
                const { message, ok } = parseRequestByConnection(res);
                dataLayerForCBPhonePushWrapper({ ...res, option, isPopup });
                this.openPopupResult(ok, message);
            })
            .catch(err => {
                captureException(err);
                this.openPopupResult(false);
                dataLayerForCBPhonePush({
                    requestId: null,
                    action: ACTIONS.error,
                });
            });
    };

    openPopupResult = (result, resText) => {
        result
            ? this.setState({
                isAuthOpened: false,
                isResult: true,
                resultType: 'success',
                resultTitle: 'Заявка на подключение отправлена',
                resultText: 'Мы свяжемся с вами в ближайшее время',
            })
            : this.setState({
                isAuthOpened: false,
                isResult: true,
                resultType: 'error',
                resultTitle: 'Произошла ошибка',
                resultText: resText ? resText : '',
            });
    };

    sendEvent = (action) => {
        dataLayerPush({
            event: EVENTS.UAevent,
            category: 'Whether our client or not',
            action: action,
        });
    };

    routerRequest = () => {
        const { selectRouter } = this.state;
        const { materialsEnsId } = selectRouter.router;
        const { type, price, value } = selectRouter.option;
        this.sendEvent('go to request');
        location.href = `/request?materialsEnsId=${materialsEnsId}&${type === EPriceTypes.Possess ? 'posess_price' : `leasing-duration=${value}&leasing_price`}=${price}`;
    };

    routerAuth = () => {
        this.sendEvent('go to authorization');
        location.href = '/user/login?referrer=/internet/equipment&forceRedirect=true';
    };

    initOrder = async(router, selectedPrice) => {
        const { isAuth, services } = this.props;
        if (isAuth && services.find((service) => service.productId === PRODUCT_INTERNET_ID)) {
            const { category: { name: categoryName }, global_id: ensId } = router;
            const { value: leasing } = selectedPrice;
            const productId = (categoryName === 'routers') ? PRODUCT_INTERNET_ID : PRODUCT_TV_ID;

            dataLayerPush({
                event: EVENTS.UAevent,
                category: 'full-buy-equip',
                action: 'clicked_to_order',
                label: '/full_buy_router',
            });

            Router.push(`/full-buy-equip?ensId=${ensId}&productId=${productId}&leasing=${leasing}`);

            return;
        }

        this.setState({
            selectRouter: {
                router,
                option: selectedPrice,
            },
            isAuthOpened: true,
        }, () => {
            dataLayerPush({
                event: EVENTS.UAevent,
                category: 'click btn buy equipment',
                action: router.materialsEnsName,
                label: selectedPrice.type === EPriceTypes.Possess
                    ? PURCHASE_TEXT
                    : `${INSTALLMENT_TEXT} ${selectedPrice.value} мес.`,
            });
        });
    };

    closeAuth = () => {
        this.setState({ isAuthOpened: false });
    };

    closeResult = () => {
        this.setState({
            requestTitle: null,
            requestText: null,
            isResult: false,
        });
    };

    onBannerRouterClick = ({ clickType }) => {
        dataLayerPush({
            'event': 'UAevent',
            'category': 'banner',
            'action': `click banner to ${clickType === 'clickOnBanner' ? 'req full' : 'req'}`,
            'label': window.location.pathname,
        });

        window.location.href = this.props.banner.link;
    }

    render() {
        const { clientRouter, isAuthOpened, resultTitle, resultText, resultType, isResult, isAuth, selectRouter } = this.state;
        const { currentCity, productList, questions, banner } = this.props;

        let title = <Title auth={isAuth}>Wi-Fi роутеры</Title>;

        if (currentCity.domain === 'interzet') {
            title = <Title auth={isAuth}>Wi-Fi роутеры в {currentCity.cityIn}</Title>;
        }

        return (
            <Wrapper>
                {
                    isAuth && clientRouter
                        ? <GridContainer>
                            <ClientRouter clientRouter={clientRouter}/>
                        </GridContainer>
                        : null
                }
                {(!isAuth || !clientRouter) && <GridContainer>
                    {title}
                </GridContainer>}
                <RouterListContainer>
                    <GridContainer>
                        {isAuth && clientRouter ? <RouterListTitle>Выберите Wi-Fi роутер</RouterListTitle> : null}
                        <DevicesGrid
                            dataTest='router-list'
                            createOrder={this.initOrder}
                            devices={productList}
                            currentCity={currentCity}
                            baseRoute='/internet/equipment'
                        />
                    </GridContainer>
                </RouterListContainer>

                {
                    questions && questions.length > 0 &&
                    <QuizSection>
                        <GridContainer>
                            <QuizBlock />
                        </GridContainer>
                    </QuizSection>
                }

                {
                    banner &&
                    <GridContainer>
                        <BannerRouter
                            onClickHandler={this.onBannerRouterClick}
                            banner={banner}
                        />
                    </GridContainer>
                }

                <GridContainer>
                    <InfoContainer>
                        <Info city={currentCity}/>
                    </InfoContainer>
                </GridContainer>

                <OrderPopup
                    isOpened={isAuthOpened}
                    closeClick={this.closeAuth}
                    sendRequest={this.createOrderUnauth}
                    selectRouter={selectRouter}
                    formRef='popupRequest'
                    isPopup={true}
                />

                <PopupResult
                    isOpen={isResult}
                    onClose={this.closeResult}
                    title={resultTitle}
                    text={resultText}
                    type={resultType}
                />
            </Wrapper>
        );
    }
}

const mapStateToProps = (state) => ({
    isAuth: state.auth.isAuth,
    currentCity: state.city.currentCity,
    accessToken: state.auth.accessToken,
    questions: state.quiz.questions,
    billingDomain: selectDomain(state),
    services: state.auth?.clientProducts?.services,
});

export default connect(
    mapStateToProps,
)(Main);
